import React, { Component, Fragment } from 'react';
import { Container } from 'semantic-ui-react';
import Step1 from './service-not-available/Step1';
import Step2 from './service-not-available/Step2';
import Step3 from './service-not-available/Step3';
import Step4 from './service-not-available/Step4';
import Step5 from './service-not-available/Step5';
import Step6 from './service-not-available/Step6';
import { connect } from 'react-redux';
import RequestFibreStreamEmail from './service-not-available/RequestFibreStreamEmail';
import UnAvailable from './service-not-available/UnAvailable';
import AddYourAddress from './service-not-available/AddYourAddress';
import ServiceIsAvailable from './service-not-available/ServiceIsAvailable';
import ComingSoon from './service-not-available/ComingSoon';
import Unknown from './service-not-available/Unknown';
import { setTitle, setMetaDescription } from '../../util';

class ServiceNotAvailable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: this.getActiveStep(props.result_type),
      animation: "fade left"
    };

    this.changeStep = this.changeStep.bind(this);
  }

  componentDidMount() {
    document.title = setTitle(this.props.title);
    setMetaDescription(this.props.description);
  }

  getActiveStep(result_type) {
    let activeStep;
    switch (result_type) {
      case 2:
        activeStep = 5;
        break;
      case 3:
        activeStep = 7;
        break;
      case 4:
        activeStep = 8;
        break;
      case null:
        activeStep = 9;
        break;
      default:
        activeStep = 1
    }
    return activeStep;
  }

  changeStep(step, animation) {
    window.scrollTo(0, 0);
    this.setState({
      activeStep: step,
      animation: animation
    });
  }

  renderStep() {
    const { activeStep, animation } = this.state;

    switch (activeStep) {
      case 1:
        return <Step1 setServiceAvailable={this.props.setServiceAvailable} changeStep={this.changeStep} animation={animation} />
      case 2:
        return <Step2 changeStep={this.changeStep} animation={animation} />
      case 3:
        return <Step3 changeStep={this.changeStep} animation={animation} />
      case 4:
        return <Step4 changeStep={this.changeStep} animation={animation} />
      case 5:
        return <Step5 setServiceAvailable={this.props.setServiceAvailable} changeStep={this.changeStep} animation={animation} />
      case 6:
        return <Step6 changeStep={this.changeStep} animation={animation} />
      case 7:
        return <RequestFibreStreamEmail setServiceAvailable={this.props.setServiceAvailable} changeStep={this.changeStep} animation={animation} />
      case 8:
        return <UnAvailable setServiceAvailable={this.props.setServiceAvailable} changeStep={this.changeStep} animation={animation} />
      case 9:
        return <AddYourAddress changeStep={this.changeStep} animation={animation} />
      case 10:
        return <ServiceIsAvailable changeStep={this.changeStep} animation={animation} />
      case 11:
        return <ComingSoon changeStep={this.changeStep} animation={animation} />
      case 12:
        return <Unknown changeStep={this.changeStep} animation={animation} />
      default:
    }
  }

  render() {
    return (
      <Fragment>
        <section className="check-availability space">
          <Container>
            {this.renderStep()}
          </Container>
        </section>
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    result_type: state.connection.result_type
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ServiceNotAvailable);


// WEBPACK FOOTER //
// ./src/components/check-availability/ServiceNotAvailable.js